import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatDialog, MatPaginator, MatSort, MAT_DIALOG_DATA } from '@angular/material';
import { ngClassColorBtn3, ngClassAceptarModal, ngClassSalirModal, isEmptyList, isNotEmptyList, iconVer, openModalMensaje, isEmpty, DscTituloPaginator, isNotEmpty, iconAgregar, dscEtiquetaBtnAcepModal, dscEtiquetaBtnSalirModal, strMatTablePaginator, NumIdTipoCatObjSeace } from 'src/app/general/variables';
import { FichaXContratacion } from 'src/app/models/FichaXContratacion';
import { ContratacionSEACE } from 'src/app/models/ContratacionSEACE';
import { FichaXConratacionXHi } from 'src/app/models/FichaXContratacionXHi';
import { ModalRegHechoirreContrComponent } from '../modal-reg-hechoirre-contr/modal-reg-hechoirre-contr.component';
import { Contratacion } from 'src/app/models/Contratacion';
import { Entidad } from 'src/app/models/Entidad';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { ModalDetalleContratacionComponent } from '../modal-detalle-contratacion/modal-detalle-contratacion.component';
import { SeaceService } from 'src/app/services/seace.service.';
import { ObjetoSeace } from 'src/app/models/ObjetoSeace';
import { TipoSeleccionSeace } from 'src/app/models/TipoSeleccionSeace';
import { AnhoService } from 'src/app/services/Anho.service';
import { BusqEntidadComponent } from '../../general/busq-entidad/busq-entidad.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnhoConvSeace } from 'src/app/models/AnhoConvSeace';
import { ModalidadSelecSeace } from 'src/app/models/ModalidadSelecSeace';
import { ProvinciaService } from 'src/app/services/provincia.service';
import { DistritoService } from 'src/app/services/distrito.service';
import { Departamento } from 'src/app/models/Departamento';
import { Distrito } from 'src/app/models/Distrito';
import { Provincia } from 'src/app/models/Provincia';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';
import { TipoCompraSeace } from 'src/app/models/TipoCompraSeace';
import { Anho } from 'src/app/models/Anho';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { Catalogo } from 'src/app/models/Catalogo';

@Component({
  selector: 'app-modal-busq-contratacion',
  templateUrl: './modal-busq-contratacion.component.html',
  styleUrls: ['./modal-busq-contratacion.component.css']
})
export class ModalBusqContratacionComponent implements OnInit {

  ngClassColorBtn3 = ngClassColorBtn3;
  ngClassAceptarModal = ngClassAceptarModal;
  dscEtiquetaBtnAcepModal = dscEtiquetaBtnAcepModal;
  dscEtiquetaBtnSalirModal = dscEtiquetaBtnSalirModal;
  ngClassSalirModal = ngClassSalirModal;
  flgMostrarAvanzada = false;
  isEmptyList = isEmptyList;
  isNotEmptyList = isNotEmptyList;
  listFichaXContr: FichaXContratacion[] = [];
  iconVer = iconVer;
  listContratacionSEACE: ContratacionSEACE[] = [];
  strDscTitulo = 'Contrataciones';
  listHechoIrregular: FichaXConratacionXHi[] = null;
  strCodEntidad: string = null;
  strNroRuc: string = null;
  strObjContr: string = null;
  strDscObjeto: string = null;
  strTipoSeleccion: string = null;
  strNroSeleccion: string = null;
  strAnhoConvIni: string = null;
  strAnhoConvFin: string = null;
  strCodSnip: string = null;
  strModalSelecc: string = null;
  strCodDepart: string = null;
  strIdentConvoc: string = null;
  strCodProv: string = null;
  strTipoCompra: string = null;
  strCodDistrito: string = null;
  strDscEntidad: string = null;
  strDscProcSelecc: string = null;
  strDescripcion: string = null;


  // listaObjetoSeace:ObjetoSeace[] = [];
  listaObjetoSeace: Catalogo[] = [];

  listaTipoSeleccionSeace: TipoSeleccionSeace[] = [];
  listaAnho: AnhoConvSeace[] = [];
  listaModalidad: ModalidadSelecSeace[] = [];
  listaDepartamento: Departamento[] = [];
  listaProvincia: Provincia[] = [];
  listaDistrito: Distrito[] = [];
  listaTipoCompra: TipoCompraSeace[] = [];
  listAnho: Anho[] = [];
  strObjCont: string = null;

  iconAgregar = iconAgregar;
  // ngClassAceptarModal = ngClassAceptarModal;


  dataSource: MatTableDataSource<ContratacionSEACE>;
  matTableColumnsDef = ['nomenclatura', 'objeto', 'valor', 'seleccionar', 'irregularidad'];
  matTableColumnsEtiq = ['Nomenclatura', 'Descripción de Objeto', 'Valor Referencial', 'Seleccionar', 'Irregularidad'];
  strMatTablePaginator = strMatTablePaginator;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(NavModalComponent) navModalC: NavModalComponent;
  @ViewChild(BusqEntidadComponent) busqEntidadC: BusqEntidadComponent;



  constructor(private dialogRef: MatDialogRef<ModalBusqContratacionComponent>,
              public dialog: MatDialog,
              protected seaceService: SeaceService,
              protected anhoService: AnhoService,
              @Inject(MAT_DIALOG_DATA) public data: any,

              protected provinciaService: ProvinciaService,
              protected distritoService: DistritoService,
              protected maestraService: MaestrasService,
              protected catalogoService: CatalogoService,


              private spinner: NgxSpinnerService) { }

  ngOnInit() {


    this.strNroRuc = this.data.ruc;

    this.navModalC.setDatosNavModal2('Búsqueda General de Contrataciones');

    this.anhoService.listarAnho().subscribe(
      data => {
        this.listAnho = data;
      });

    this.catalogoService.listarCatalogo(NumIdTipoCatObjSeace).subscribe(data => {
      this.listaObjetoSeace = data;
    });

  }

  _checkSeleccionar(nroExpediente: number, data: any) {

    this.listContratacionSEACE.forEach(data1 => {

          if (data1.nroExpediente == nroExpediente) {

            data1.flgSeleccionar = data.target.checked;

          } else {

            data1.flgSeleccionar = false;
          }
      });

  }

  _agregarIrregularidad(data: ContratacionSEACE) {

    let vListHechoIrregular: FichaXConratacionXHi[] = [];

    // var vContratacionSEACE:ContratacionSEACE = null;

    if (!data.flgSeleccionar) {
      openModalMensaje(this.strDscTitulo, 'Primero seleccione la contratación', this.dialog);
      return;
    }

    vListHechoIrregular = this.listHechoIrregular;

    const dialogRef = this.dialog.open(ModalRegHechoirreContrComponent, {
      // width: '50%',height:'87%',
      width: '80%', height: '87%',
      data: {listHi : vListHechoIrregular}});

    dialogRef.afterClosed().subscribe(result => {

      if (result != null) {
        this.listHechoIrregular = result;
      }

      // console.log(this.furObraPublica);

    });

    // Falta la homologaci+on de datos con this.obraPublica

  }

  _aceptar() {

    let vFichaXContr: FichaXContratacion = null;
    const vContratacionSeace: ContratacionSEACE = this.listContratacionSEACE.find(x => x.flgSeleccionar == true);

    if (isEmptyList(vContratacionSeace) || isEmptyList(this.listHechoIrregular)) {

      openModalMensaje(this.strDscTitulo, 'Debe seleccionar la contratación y los hechos irregulares, por favor verifique', this.dialog);

      return;

    }

    vFichaXContr = new FichaXContratacion();

    vFichaXContr.contratacion = new Contratacion();

    vFichaXContr.contratacion.ccontratacionDscnomenclatura = String(vContratacionSeace.nroExpediente);
    vFichaXContr.contratacion.ccontratacionDscobjeto = vContratacionSeace.objeto;
    vFichaXContr.contratacion.ncontratacionImpmonto = Number(vContratacionSeace.cValretOrig);
    vFichaXContr.contratacion.ncontratacionImpvalorest = Number(vContratacionSeace.cValretOrig);
    vFichaXContr.contratacion.ccontratacionDscobjcont = vContratacionSeace.descripcion;
    vFichaXContr.contratacion.ccontratacionDscmoneda = vContratacionSeace.moneda;
    vFichaXContr.contratacion.ccontratacionDscmodaselecc = vContratacionSeace.modalidadSeleccion;
    vFichaXContr.contratacion.ccontratacionDscnormativa = vContratacionSeace.normativaAplicable;
    vFichaXContr.contratacion.ccontratacionNroselecc = vContratacionSeace.procesosel;
    vFichaXContr.contratacion.ccontratacionNroruc = vContratacionSeace.ruc;
    vFichaXContr.contratacion.ccontratacionDsctipselecc = vContratacionSeace.tipoProceso;


    // vFichaXContr.contratacion.ccontratacionDscnomenclatura = vContratacionSeace.nomenclatura;
    // vFichaXContr.contratacion.ccontratacionDscobjeto = vContratacionSeace.desc_objeto;
    // vFichaXContr.contratacion.ncontratacionImpmonto = Number(vContratacionSeace.valor_referencial);
    // vFichaXContr.contratacion.ccontratacionDscobjcont = vContratacionSeace.dsc_contratacion;
    // vFichaXContr.contratacion.ccontratacionNroselecc = vContratacionSeace.num_seleccion;
    // vFichaXContr.contratacion.ncontratacionIdmoneda = Number(vContratacionSeace.moneda);
    // vFichaXContr.contratacion.ccontratacionCdepent = vContratacionSeace.cod_departamento;
    // vFichaXContr.contratacion.ccontratacionCprovent = vContratacionSeace.cod_provincia;
    // vFichaXContr.contratacion.ccontratacionCdistent = vContratacionSeace.cod_distrito;
    // vFichaXContr.contratacion.ccontratacionDscdirlegent = vContratacionSeace.direccion_legal;
    // vFichaXContr.contratacion.ccontratacionDscversseace = vContratacionSeace.version_seace;
    // vFichaXContr.contratacion.ccontratacionDsctelefent = vContratacionSeace.telefono_entidad;
    // vFichaXContr.contratacion.ccontratacionDscnormativa = vContratacionSeace.normativa_aplicable;
    // vFichaXContr.contratacion.ccontratacionNroruc = vContratacionSeace.num_ruc;
    // vFichaXContr.contratacion.ccontratacionCodsnip = vContratacionSeace.cod_snip;
    // vFichaXContr.contratacion.ccontratacionDsctipselecc = vContratacionSeace.dsc_tipo_selec;
    // vFichaXContr.contratacion.ccontratacionCodanho = vContratacionSeace.dsc_anio;
    // vFichaXContr.contratacion.ccontratacionDsctipcompra = vContratacionSeace.dsc_tipo_compra;

    vFichaXContr.listaFichaPorContratacionPorHechoIrregular = this.listHechoIrregular;

    this.dialogRef.close(vFichaXContr);

  }

  cambiarDepartamento(idDepartamento: string) {


    this.maestraService.obtenerProvincias(idDepartamento).subscribe(data => {


        this.listaProvincia = data;

        this.strCodProv = null;
        this.strCodDistrito = null;

     });

  }

  cambiarProvincia(idProvincia: string, idDepartamento: string) {
     this.maestraService.obtenerDistritos(idDepartamento, idProvincia).subscribe(data => {
         this.listaDistrito = data;

         this.strCodDistrito = null;
     });
  }

  _resetListado() {

    this.listFichaXContr = [];

    this._resetMatTable();

  }

  _resetMatTable() {

    setTimeout(() => {

      this.dataSource = new MatTableDataSource(this.listContratacionSEACE);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

      // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 1);

  }

  _verDetalle(data: ContratacionSEACE) {

    let vListaHechoIrregular: FichaXConratacionXHi[] = [];

    if (data.flgSeleccionar) {

      vListaHechoIrregular = JSON.parse( JSON.stringify(this.listHechoIrregular) );

    }

    this.dialog.open(ModalDetalleContratacionComponent, { width: '70%', height: '87%', data: {contratacion : data, listaHi: vListaHechoIrregular}});


  }

  _mayusculas(e) {

    let vData = '';

    e.target.value = e.target.value.toUpperCase();

    // vData = e.target.value.trim();
    vData = e.target.value;

    e.target.value = vData;

    this.strDescripcion = vData;

   }

  _buscar() {

    let vContratacionSeace: ContratacionSEACE = null;
    let vListContratacionSeace: ContratacionSEACE[] = [];
    const strAnhoDesde: string = this.strAnhoConvIni;
    const strAnhoHasta: string = this.strAnhoConvFin;
    let numAnhoDesde: number = null;
    let numAnhoHasta: number = null;

    this._resetListado();

    if (isEmpty(this.strNroRuc) && isEmpty(this.strDscProcSelecc)) {

      openModalMensaje(this.strDscTitulo, 'Debe ingresar el ruc o la nomenclatura, por favor verifique', this.dialog);

      return;

    }

    if (!isEmpty(strAnhoDesde) || !isEmpty(strAnhoHasta)) {

      if ((!isEmpty(strAnhoDesde) && isEmpty(strAnhoHasta)) || (isEmpty(strAnhoDesde) && !isEmpty(strAnhoHasta))) {

        openModalMensaje(this.strDscTitulo, 'Debe ingresar correctamente el rango de años, por favor verifique', this.dialog);

        return;

      }

      numAnhoDesde = Number(strAnhoDesde);
      numAnhoHasta = Number(strAnhoHasta);

      if (numAnhoDesde > numAnhoHasta) {

        openModalMensaje(this.strDscTitulo, 'El año inicial no debe ser mayor al final, por favor verifique', this.dialog);

        return;

      }

    }

    vContratacionSeace = new ContratacionSEACE();

    if (!isEmpty(this.strNroRuc)) {

      vContratacionSeace.ruc = this.strNroRuc;

    }

    if (!isEmpty(this.strDscProcSelecc)) {

      vContratacionSeace.procesosel = this.strDscProcSelecc;

    }

    vContratacionSeace.descripcion = this.strDescripcion;
    // vContratacionSeace.cAnocon = this.strAnhoConvIni;
    vContratacionSeace.cAnocon = this.strAnhoConvIni;
    vContratacionSeace.cValretOrig = this.strAnhoConvFin;
    vContratacionSeace.objeto = this.strObjCont;

    this.spinner.show();

    // console.log("=========vContratacionSeace");
    // console.log(JSON.stringify(vContratacionSeace) );

    this.listContratacionSEACE = [];

    this.seaceService.buscarContratacionSeace(vContratacionSeace).subscribe(

      data => {

        this.spinner.hide();

        vListContratacionSeace = data;

        // console.log("===========vListContratacionSeace");
        // console.log(vListContratacionSeace);

        if (isNotEmptyList(vListContratacionSeace)) {

          // = ;

          // this.listContratacionSEACE = [];

          vListContratacionSeace.forEach((element, index) => {

            element.flgSeleccionar = false;

            this.listContratacionSEACE.push(element);

          });

          this._resetMatTable();

        } else {
          openModalMensaje(this.strDscTitulo, 'No se encuentran registros con los parámetros de búsqueda,verifique por favor', this.dialog);

        }

        this._resetMatTable();

      },
      err => {

        this.spinner.hide();

        console.log(err);

      }
    );

  }

  _busquedaAvanzada() {

    this.flgMostrarAvanzada = true;

  }

  setFlgMostrarBusqAvanzada(flgValor: boolean) {

    this.flgMostrarAvanzada = flgValor;

  }

  _cancelar() {
    this.dialogRef.close();
  }

  _setCodEntidadOut(entidadSelec: Entidad) {

    this.strCodEntidad = entidadSelec.centCodigo;
    this.strNroRuc = entidadSelec.centRuc;
    this.strDscEntidad = entidadSelec.centNombre;

  }

}
